'use strict';

const _ = require('lodash');

const wixCodeLogLevel = require('./wixCodeLogLevel');

const consoleMethodsToWrap = {
  info: wixCodeLogLevel.INFO,
  warn: wixCodeLogLevel.WARN,
  error: wixCodeLogLevel.ERROR,
  log: wixCodeLogLevel.LOG
};

function _toArray(args) {
  return Array.prototype.map.call(args, function(v) {
    if (v instanceof Error) {
      return v.toString();
    }
    const vt = typeof v;
    if (vt === 'string' || vt === 'boolean' || vt === 'number' || v === null || v === undefined) {
      return v;
    }
    if (Array.isArray(v)) {
      return _toArray(v);
    }
    if (vt === 'function') {
      return v.toString();
    }
    try {
      return JSON.stringify(v);
    } catch (e) {
      return v.toString();
    }
  });
}

function _wrapConsoleMethod(consoleInstance, logLevel, sendCallback, originalFunc) {
  return function() {
    const stack =
            _.isError(arguments[0]) ?
              arguments[0].stack :
              (new Error()).stack;

    const messageData = {logLevel,
      args: _toArray(arguments),
      stack};
    sendCallback(messageData);
    originalFunc.apply(consoleInstance, arguments);
  };
}

function wrapConsole(consoleInstance, sendCallback) {
  const originalLog = consoleInstance.log || _.noop;
  for (const method in consoleMethodsToWrap) {
    if (consoleMethodsToWrap.hasOwnProperty(method) && consoleInstance.hasOwnProperty(method)) {
      consoleInstance[method] = _wrapConsoleMethod(consoleInstance, consoleMethodsToWrap[method], sendCallback, consoleInstance[method]);
    }
  }
  consoleInstance.verbose = _wrapConsoleMethod(consoleInstance, wixCodeLogLevel.VERBOSE, sendCallback, originalLog);

  //TODO: remove right after WCD-6723 is complete
  consoleInstance.serverLog = _.noop;

  return consoleInstance;
}

module.exports = {
  wrapConsole
};
